<template>
  <div>
    <h1>Editor</h1>
  </div>
</template>

<script>
export default {
  name: 'Editor'
}

</script>

<style scoped>

</style>